import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { A4 } from './CvTemplates';

// يلتقط صفحة السيرة كصورة واحدة بدقة عالية (3x ≈ 288dpi) مع ضمان صفحة A4 واحدة بالضبط
export const renderCvCanvas = async (pageEl, quality = 4) => {
  const inner = pageEl.querySelector('[data-cv-inner]');
  if (!inner) return null;
  const prevTransform = inner.style.transform;
  const naturalW = inner.offsetWidth || A4.w;
  const captureScale = quality * (A4.w / naturalW);

  inner.style.transform = 'none';
  if (document.fonts?.ready) { try { await document.fonts.ready; } catch { /* تجاهل */ } }
  await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

  let shot;
  try {
    shot = await html2canvas(inner, { scale: captureScale, useCORS: true, backgroundColor: null, logging: false });
  } finally {
    inner.style.transform = prevTransform;
  }

  const page = document.createElement('canvas');
  page.width = Math.round(A4.w * quality);
  page.height = Math.round(A4.h * quality);
  const ctx = page.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, page.width, page.height);

  const bandColor = pageEl.dataset.bandColor;
  const bandW = Number(pageEl.dataset.bandW || 0);
  if (bandColor && bandW) {
    const w = bandW * quality;
    ctx.fillStyle = bandColor;
    ctx.fillRect(page.width - w, 0, w, page.height);
  }

  const drawH = shot.height * (page.width / shot.width);
  ctx.drawImage(shot, 0, 0, shot.width, shot.height, 0, 0, page.width, drawH);

  const brand = pageEl.querySelector('[data-cv-brand]');
  if (brand) {
    const fs = 9 * quality;
    ctx.save();
    ctx.direction = 'rtl';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#9aa4b2';
    ctx.font = `${fs}px Tajawal, Cairo, sans-serif`;
    ctx.fillText(brand.textContent.trim(), (page.width - bandW * quality) / 2, page.height - 9 * quality);
    ctx.restore();
  }
  return page;
};

export const downloadCvPdf = async (pageEl, filename) => {
  const canvas = await renderCvCanvas(pageEl, 4);
  if (!canvas) return;
  const pdf = new jsPDF('p', 'mm', 'a4');
  pdf.addImage(canvas.toDataURL('image/jpeg', 0.98), 'JPEG', 0, 0, 210, 297, undefined, 'SLOW');
  pdf.save(`${filename}.pdf`);
};

export const downloadCvPng = async (pageEl, filename) => {
  const canvas = await renderCvCanvas(pageEl, 4);
  if (!canvas) return;
  const a = document.createElement('a');
  a.href = canvas.toDataURL('image/png');
  a.download = `${filename}.png`;
  a.click();
};

// الطباعة عبر صورة بدقة عالية داخل iframe مخفي — يضمن تشكيل الحروف العربية ومطابقة المعاينة تماماً
export const printCv = async (pageEl) => {
  const canvas = await renderCvCanvas(pageEl, 4);
  if (!canvas) return;
  const dataUrl = canvas.toDataURL('image/jpeg', 0.98);
  const frame = document.createElement('iframe');
  frame.style.cssText = 'position:fixed;width:0;height:0;border:0;left:-9999px;';
  document.body.appendChild(frame);
  const doc = frame.contentDocument;
  doc.open();
  doc.write(`<!doctype html><html><head><style>
    @page { size: A4 portrait; margin: 0; }
    html,body { margin:0; padding:0; }
    img { width:210mm; height:297mm; display:block; }
    @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
  </style></head><body><img src="${dataUrl}" /></body></html>`);
  doc.close();
  const img = doc.querySelector('img');
  const go = () => {
    frame.contentWindow.focus();
    frame.contentWindow.print();
    setTimeout(() => document.body.removeChild(frame), 2000);
  };
  if (img.complete) setTimeout(go, 150); else img.onload = () => setTimeout(go, 150);
};
